module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.fullLoading),
      expression: "fullLoading",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "page-consume"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.appLoading),
      expression: "appLoading",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "game-info"
  }, [(_vm.appList.length > 0 && !_vm.appLoading) ? [_c('div', {
    staticClass: "method-container"
  }, [_c('div', {
    staticClass: "method-select game-list"
  }, [_c('div', {
    staticClass: "swiper-button-prev",
    slot: "button-prev"
  }), _vm._v(" "), _c('swiper', {
    attrs: {
      "options": _vm.consumeSwiper
    }
  }, _vm._l((_vm.appList), function(app, appIndex) {
    return _c('swiper-slide', {
      staticClass: "game-item"
    }, [_c('img', {
      staticClass: "game-logo",
      class: {
        'app-active': _vm.selectedAppIndex == appIndex
      },
      attrs: {
        "src": app.iconUrl
      },
      on: {
        "click": function($event) {
          _vm.selectedAppIndex = appIndex
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "game-name"
    }, [_vm._v(_vm._s(app.appName))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    slot: "button-next"
  })], 1)])] : _vm._e(), _vm._v(" "), (_vm.appList.length == 0 && !_vm.appLoading) ? [_c('p', {
    staticClass: "no-game"
  }, [_vm._v(_vm._s(_vm.$t('noGames')))])] : _vm._e()], 2), _vm._v(" "), (_vm.appList.length > 0 && !_vm.appLoading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.goodsLoading),
      expression: "goodsLoading",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "goods-content"
  }, [(_vm.goodsList.length > 0 && !_vm.goodsLoading) ? [_c('div', {
    staticClass: "goods-list"
  }, _vm._l((_vm.goodsList), function(goods, goodsIndex) {
    return _c('div', {
      staticClass: "goods-item",
      class: {
        'goods-active': _vm.selectedGoodsIndex == goodsIndex
      },
      on: {
        "click": function($event) {
          _vm.selectedGoodsIndex = goodsIndex
        }
      }
    }, [_c('div', {
      staticClass: "goods-name"
    }, [_vm._v(_vm._s(goods.goodsName))]), _vm._v(" "), _c('div', {
      staticClass: "goods-price"
    }, [_vm._v("\n                        " + _vm._s(Math.ceil(goods.price * 100)) + " " + _vm._s(_vm.$t('egPoint')) + "\n                    ")]), _vm._v(" "), _vm._m(0, true)])
  })), _vm._v(" "), _c('el-button', {
    staticClass: "buy-btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.checkIsPlayedGame
    }
  }, [_vm._v(_vm._s(_vm.$t('purchase')) + "\n            ")])] : _vm._e(), _vm._v(" "), (_vm.goodsList.length == 0 && !_vm.goodsLoading) ? [_c('div', {
    staticClass: "no-goods"
  }, [_vm._v(_vm._s(_vm.$t('noGoods')))])] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.showConsume) ? _c('popup', {
    attrs: {
      "title": _vm.$t('confirmOrder'),
      "id": "popup",
      "showHeader": true,
      "showPopupLoading": _vm.popupLoading
    },
    on: {
      "close": _vm.closePopup
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.goodsOrder,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('goodsName')
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.goodsOrder.goodsName),
      expression: "goodsOrder.goodsName"
    }],
    attrs: {
      "disabled": true
    },
    domProps: {
      "value": (_vm.goodsOrder.goodsName)
    },
    on: {
      "input": function($event) {
        _vm.goodsOrder.goodsName = $event
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('goodsPrice')
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.goodsOrder.goodsPrice),
      expression: "goodsOrder.goodsPrice"
    }],
    attrs: {
      "disabled": true
    },
    domProps: {
      "value": (_vm.goodsOrder.goodsPrice)
    },
    on: {
      "input": function($event) {
        _vm.goodsOrder.goodsPrice = $event
      }
    }
  })], 1), _vm._v(" "), (_vm.gamePlayed && _vm.goodsInfo.appId == 1005) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('gameArea')
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.areaId),
      expression: "areaId"
    }],
    attrs: {
      "placeholder": _vm.$t('gameArea')
    },
    domProps: {
      "value": (_vm.areaId)
    },
    on: {
      "change": _vm.getServerList,
      "input": function($event) {
        _vm.areaId = $event
      }
    }
  }, _vm._l((_vm.areaList), function(areaName, areaId) {
    return _c('el-option', {
      attrs: {
        "label": areaName,
        "value": areaId
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.gamePlayed) ? [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('gameServer')
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.serverId),
      expression: "serverId"
    }],
    attrs: {
      "placeholder": _vm.$t('selectGameServer'),
      "icon": "loading"
    },
    domProps: {
      "value": (_vm.serverId)
    },
    on: {
      "change": _vm.getRoleInfo,
      "input": function($event) {
        _vm.serverId = $event
      }
    }
  }, _vm._l((_vm.serverList), function(server) {
    return _c('el-option', {
      attrs: {
        "label": server.serv_name,
        "value": server.serv_id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('roleName')
    }
  }, [(_vm.roles.length > 0 && _vm.roles[0].roleName) ? _c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.roleIndex),
      expression: "roleIndex"
    }],
    attrs: {
      "placeholder": "",
      "disabled": _vm.roles.length > 1 ? false : true
    },
    domProps: {
      "value": (_vm.roleIndex)
    },
    on: {
      "input": function($event) {
        _vm.roleIndex = $event
      }
    }
  }, _vm._l((_vm.roles), function(role, roleIndex) {
    return _c('el-option', {
      attrs: {
        "label": role.roleName,
        "value": roleIndex
      }
    })
  })) : _c('el-input', {
    attrs: {
      "value": _vm.$t('noRoleMsg'),
      "disabled": true
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('loginPassword')
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.goodsOrder.password),
      expression: "goodsOrder.password",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.goodsOrder.password)
    },
    on: {
      "input": function($event) {
        _vm.goodsOrder.password = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })], 1)] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [(_vm.gamePlayed) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.validate
    }
  }, [_vm._v(_vm._s(_vm.$t('confirmBuy')))]) : _vm._e(), _vm._v(" "), (!_vm.gamePlayed) ? _c('a', {
    staticClass: "el-button el-button--primary",
    attrs: {
      "href": _vm.appList[this.selectedAppIndex].appDownload
    }
  }, [_vm._v(_vm._s(_vm.$t('downloadGame')))]) : _vm._e(), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v(_vm._s(_vm.$t('cancelBuy')))])], 1)], 2)], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "goods-select-mark"
  }, [_c('i', {
    staticClass: "el-icon-check"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-19bd4bb9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/store/Consume.vue
// module id = 367
// module chunks = 4